var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { range } from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { ODModal, ODModalBody, ODModalHeader, ODModalSize } from '..';
import { ODIcon, ODIcons } from '../../../icons';
import { ODWebUtils } from '../../../utils';
import { ODListablePaginatedTable2, ODListablePagination, ODListableSearchBox, useODListableContext, } from '../../listable';
import { ODButton, ODButtonTheme } from '../../misc';
export function usePickerTableModal(options) {
    var pickDefaultOptions = options.pickDefaultOptions, size = options.size, rounded = options.rounded, keyExtractor = options.keyExtractor, numColumns = options.numColumns, renderTD = options.renderTD, renderTH = options.renderTH, dataLoader = options.dataLoader, _a = options.singleSelection, singleSelection = _a === void 0 ? false : _a;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var onClickYes = React.useRef(function () { return undefined; });
    var onClickNo = React.useRef(function () { return undefined; });
    var _c = React.useState(''), title = _c[0], setTitle = _c[1];
    var _d = React.useState('Confirm'), confirmButtonTitle = _d[0], setConfirmButtonTitle = _d[1];
    var _e = React.useState(false), showSearch = _e[0], setShowSearch = _e[1];
    var _f = React.useState(''), searchPlaceholder = _f[0], setSearchPlaceholder = _f[1];
    var _g = React.useState([]), selectedItemIds = _g[0], setSelectedItemIds = _g[1];
    var selectedItemIdsRef = React.useRef([]);
    var selectedItemsRef = React.useRef([]);
    var _h = React.useState(true), returnIdsOnly = _h[0], setReturnIdsOnly = _h[1];
    var _j = useODListableContext(), Provider = _j.Provider, Context = _j.Context;
    var pick = React.useCallback(function (pickerOptions) {
        if (pickerOptions === void 0) { pickerOptions = {}; }
        var _a = __assign(__assign({}, pickerOptions), pickDefaultOptions), 
        // tslint:disable-next-line:no-shadowed-variable
        title = _a.title, 
        // tslint:disable-next-line:no-shadowed-variable
        _b = _a.confirmButtonTitle, 
        // tslint:disable-next-line:no-shadowed-variable
        confirmButtonTitle = _b === void 0 ? 'Confirm' : _b, 
        // tslint:disable-next-line:no-shadowed-variable
        _c = _a.showSearch, 
        // tslint:disable-next-line:no-shadowed-variable
        showSearch = _c === void 0 ? false : _c, 
        // tslint:disable-next-line:no-shadowed-variable
        _d = _a.searchPlaceholder, 
        // tslint:disable-next-line:no-shadowed-variable
        searchPlaceholder = _d === void 0 ? '' : _d, 
        // tslint:disable-next-line:no-shadowed-variable
        _e = _a.selectedItems, 
        // tslint:disable-next-line:no-shadowed-variable
        selectedItems = _e === void 0 ? [] : _e, 
        // tslint:disable-next-line:no-shadowed-variable
        _f = _a.returnFullValue, 
        // tslint:disable-next-line:no-shadowed-variable
        returnFullValue = _f === void 0 ? false : _f;
        setTitle((title !== null && title !== void 0 ? title : '-'));
        setConfirmButtonTitle(confirmButtonTitle);
        setShowSearch(showSearch);
        setSearchPlaceholder(searchPlaceholder);
        if (returnFullValue) {
            setSelectedItemIds(!singleSelection ? selectedItems.map(function (v) { return keyExtractor(v); }) || [] : []);
            selectedItemsRef.current = selectedItems;
        }
        else {
            // @ts-ignore
            setSelectedItemIds(!singleSelection ? selectedItems || [] : []);
        }
        setReturnIdsOnly(!returnFullValue);
        return new Promise(function (resolve) {
            onClickYes.current = function () {
                setIsOpen(false);
                if (returnFullValue) {
                    resolve(selectedItemsRef.current);
                }
                else {
                    resolve(selectedItemIdsRef.current);
                }
            };
            onClickNo.current = function () {
                setIsOpen(false);
                resolve(false);
            };
            setIsOpen(true);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var Component = React.useState(function () {
        return function (modalProps) {
            // tslint:disable-next-line:no-shadowed-variable
            var selectedItems = modalProps.selectedItems, setSelectedItems = modalProps.setSelectedItems;
            var toggleItem = function (value) {
                var key = keyExtractor(value);
                if (singleSelection) {
                    setSelectedItems([key]);
                    selectedItemsRef.current = [value];
                }
                else {
                    setSelectedItems(function (arr) {
                        var index = arr.indexOf(key);
                        if (index >= 0) {
                            arr.splice(index, 1);
                            return __spreadArrays(arr);
                        }
                        arr.push(key);
                        return __spreadArrays(arr);
                    });
                    var ref = selectedItemsRef.current;
                    var indexFound = ref.findIndex(function (v) { return keyExtractor(v) === key; });
                    if (indexFound >= 0) {
                        ref.splice(indexFound, 1);
                    }
                    else {
                        ref.push(value);
                    }
                }
            };
            var isSelected = function (key) {
                return selectedItems.indexOf(key) >= 0;
            };
            return (React.createElement(ODModal, { isOpen: modalProps.isOpen, toggle: function () { return modalProps.setIsOpen(false); }, size: size, rounded: rounded },
                React.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                    React.createElement(ODModalHeader, { title: modalProps.title, onClose: function () { return onClickNo.current(); }, headerBottomPadding: 30 },
                        React.createElement(ODIcon, { icon: ODIcons.MaterialError, style: { fontSize: 60 } })),
                    React.createElement(ODModalBody, { style: { paddingBottom: 20 } },
                        React.createElement(Provider, { dataLoader: modalProps.dataLoader, keyExtractor: function (v) { return keyExtractor(v).toString(); }, pageSize: 10, onDataLoaderError: ODWebUtils.showError, searchOnLoad: true },
                            modalProps.showSearch && (React.createElement(ODListableSearchBox, { listableContext: Context, placeholder: modalProps.searchPlaceholder, style: { flexGrow: 6 } })),
                            React.createElement(ODListablePaginatedTable2, { numColumns: numColumns + 1, listableContext: Context, renderHeader: function () { return (React.createElement("tr", null,
                                    React.createElement("th", { style: { width: 100 } }),
                                    range(0, numColumns).map(function (index) { return (React.createElement("th", { key: index }, renderTH(index))); }))); }, renderRow: function (value) {
                                    var key = keyExtractor(value);
                                    return (React.createElement(TableTR, { key: key, onClick: function () { return toggleItem(value); } },
                                        React.createElement("td", { style: {
                                                width: 100,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                            } },
                                            React.createElement("input", { style: { marginTop: 3, cursor: 'pointer' }, type: "checkbox", value: isSelected(key) ? 1 : 0, checked: isSelected(key), onChange: function () { } })),
                                        range(0, numColumns).map(function (index) { return (React.createElement("td", { key: index }, renderTD(index, value))); })));
                                }, eventParentContext: {} }),
                            React.createElement(BottomWrapper, null,
                                React.createElement("div", { style: { flexGrow: 8 } },
                                    React.createElement(ODListablePagination, { hideIfSinglePage: false, listableContext: Context })),
                                React.createElement("div", { style: { minWidth: 250 } },
                                    React.createElement(ODButton, { type: "button", style: {
                                            float: 'right',
                                            width: 200,
                                            height: 40,
                                            insetTop: 10,
                                            borderRadius: 4,
                                            lineHeight: '9px',
                                        }, theme: ODButtonTheme.Primary, onClick: function () { return onClickYes.current(); } }, modalProps.confirmButtonTitle))))))));
        };
    })[0];
    selectedItemIdsRef.current = selectedItemIds;
    var props = {
        isOpen: isOpen,
        setIsOpen: function (v) {
            setIsOpen(v);
        },
        dataLoader: dataLoader,
        title: title,
        confirmButtonTitle: confirmButtonTitle,
        size: ODModalSize.Normal,
        rounded: false,
        searchPlaceholder: searchPlaceholder,
        showSearch: showSearch,
        selectedItems: selectedItemIds,
        setSelectedItems: setSelectedItemIds,
    };
    return { Component: Component, pick: pick, props: props };
}
var BottomWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var TableTR = styled.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  :hover {\n    background-color: var(--primary10) !important;\n  }\n"], ["\n  cursor: pointer;\n  :hover {\n    background-color: var(--primary10) !important;\n  }\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=usePickerTableModal.js.map